import script from "./CourseSubjectItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseSubjectItem.vue?vue&type=script&setup=true&lang=js"

import "./CourseSubjectItem.vue?vue&type=style&index=0&id=7912e9e7&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7912e9e7"]])

export default __exports__